const state = {
  user: null,
  //Token de l'api
  token: "",
  //Le droit sélectionné par l'utilisateur
  selectedDroit: null,
  //La page d'accueil
  homePageRouteObject: { name: "parc-list", query: { size: 10 } }
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_AUTH_STATUS(state, authStatus) {
    state.authStatus = authStatus;
  },
  SET_SELECTED_DROIT(state, selectedDroit) {
    state.selectedDroit = selectedDroit;
  }
};

const actions = {
  saveToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  saveUser({ commit }, user) {
    commit("SET_USER", user);
  },
  saveSelectedDroit({ commit }, selectedDroit) {
    commit("SET_SELECTED_DROIT", selectedDroit);
  }
};

const getters = {
  user(state) {
    return state.user;
  },
  token(state) {
    return state.token;
  },
  selectedDroit(state) {
    return state.selectedDroit;
  },
  droits(state, getters) {
    return getters.isUser && state.user.droits ? state.user.droits : null;
  },
  profil(state) {
    return state.selectedDroit?.profil || null;
  },
  isUser(state) {
    return state.user != null && state.user !== undefined;
  },
  isDroits(state) {
    return state.user.droits != null && state.user.droits.length > 0;
  },
  isExploitant(state) {
    return state.selectedDroit
      ? ["Exploitant", "exploitant", "Prestataire"].includes(state.selectedDroit.profil)
      : null;
  },
  isDreal(state) {
    return state.selectedDroit
      ? ["Administrateur", "Gestionnaire", "Administrateur portail"].includes(state.selectedDroit.profil)
      : null;
  },
  isGestionnaire(state) {
    return state.selectedDroit?.profil === "Gestionnaire" ?? null;
  },
  isAdministrateur(state) {
    return state.selectedDroit?.profil === "Administrateur" ?? null;
  },
  isAdministrateurPortail(state) {
    return state.selectedDroit?.profil === "Administrateur portail" ?? null;
  },
  isSelectedProfil(state) {
    return (
      state.selectedDroit != null &&
      state.selectedDroit.profil !== null &&
      state.selectedDroit.profil !== ""
    );
  },
  administrateurRegion(state, getters) {
    return getters.isAdministrateur ? state.selectedDroit.region : null;
  },
  gestionnaireService(state, getters) {
    return getters.isGestionnaire ? state.selectedDroit.code_entite : null;
  },
  homePageRouteObject(state) {
    return state.homePageRouteObject;
  },
  oreolDroitsCount(state) {
    return state.user && state.user.droits ? state.user.droits.length : 0;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
